import Vue from 'vue'
import Vuex from 'vuex'
import {
    ElementApiModule,
    SyncsWithUrl,
    ContinuousCollectionComponent,
    ResetsPage
} from 'clockvine-vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import accordion from './mixins/accordion.js'

gsap.registerPlugin(ScrollTrigger)
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        faqs: new ElementApiModule('faq.json', { debounce: 1000 }),
    },
})

new Vue({ // eslint-disable-line no-new
    store,
    el: '#faqListing',
    components: {
        faqs: ContinuousCollectionComponent.for('faqs'),
    },
    mixins: [
        new SyncsWithUrl('params'),
        new ResetsPage(),
        accordion
    ],
    data: {
        focusIndex: 0,
        params: {
            orderBy: 'title asc',
            page: 1,
            category: null,
        },
    },
    mounted: function() {
        this.handleLoadFinish()
    },
    methods: {
        handleLoadMore () {
            this.focusIndex = this.$refs.articleList.childElementCount
            this.params.page++
        },
        handleLoadFinish (payload) {
            console.log('handle load finish')
            this.createAccordions()
            if (!payload && this.focusIndex > 0) {
                this.$refs.articleList.querySelector(`.postCard:nth-of-type(${this.focusIndex}) .postCard__heading a`).focus()
            }
        },
    },
})
